import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/shared/models/usuario.model';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import DateUtils from 'src/app/shared/utils/date-utils';

@Component({
  selector: 'app-cadastro-form',
  templateUrl: './cadastro-form.component.html',
  styleUrls: ['./cadastro-form.component.scss']
})
export class CadastroFormComponent implements AfterViewInit {

  usuario: Usuario = new Usuario();
  disableCpf: boolean = false;

  @Output()
  save: EventEmitter<Usuario> = new EventEmitter();

  @Input()
  loading = false;

  @ViewChild('inputDataNascimento')
  inputDataNascimento: any;

  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngAfterViewInit(): void {
    const preCpf = sessionStorage.getItem("preCpf");
    if (preCpf) {
      this.usuario.cpf = preCpf;
      this.disableCpf = true;
    }
    if (this.inputDataNascimento) {
      this.inputDataNascimento.control.setValidators([DateUtils.DateValidator]);
    }
  }

  get emailOuTelefoneValido(): boolean {
    return this.usuario && (!!this.usuario.telefone || !!this.usuario.email);
  }

  onSave() {
    if(this.disableCpf) {
      sessionStorage.removeItem("preCpf");
      this.disableCpf = false;
    }
    this.save.emit(this.usuario);
  }

  irParaLogin(): void {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'ja possui uma conta fazer login',
    })
    this.router.navigate([`/`], { queryParamsHandling: 'preserve' });
  }

}
